import { render, staticRenderFns } from "./ImagesManagementDetails.vue?vue&type=template&id=2ee1867c&"
import script from "./ImagesManagementDetails.vue?vue&type=script&lang=js&"
export * from "./ImagesManagementDetails.vue?vue&type=script&lang=js&"
import style0 from "./ImagesManagementDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports